module.exports = __webpack_public_path__ + "img/weather1.731fa782.png";